export default __webpack_public_path__ + "static/how-to-play-605c6c05038109d10fb05479a60a84e4.png";